<script setup>
import {useAppTheme} from '@/composables/use-app-theme.js'
const {theme} = useAppTheme()
</script>

<template>
  <img
    :src="`/logo-${theme}.svg`"
    alt="Logo"
  >
</template>
